"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tricase": {
    "00b42e72": [{
      "hkey": "e71b9058",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "caprarica": [{
      "hkey": "e71b9058",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "tricase"
    }],
    "1ec72fae": [{
      "hkey": "e71b9058",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "santa-eufemia": [{
      "hkey": "e71b9058",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "tricase"
    }],
    "a4460843": [{
      "hkey": "e71b9058",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "tutino": [{
      "hkey": "e71b9058",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "tricase"
    }]
  }
};
exports["default"] = _default;